export default function ($sceDelegateProvider) {
    'ngInject';

    let resources = process.env.RESOURCE_URL_WHITELIST.split(',');
    $sceDelegateProvider.resourceUrlWhitelist(resources);
}
